module.exports = __webpack_public_path__ + "img/Badeurlaub.5ef75db2.jpg";